/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import Filters from '../../../../components/Filters'
import Button from '../../../../components/Button'
import { ControlTable } from '../../../../components/Table';
import useForm from '../../../../hooks/useForm';
import { getParams } from '../../../../utils/params';
import { forEach, isEmpty, isNull } from 'lodash';
import systemAlert from '../../../../utils/systemAlert';
import { getDay } from '../../../../utils/date';
import { getInvoiceList } from '../../../../apis/invoices';
import { createCardRecordsUseItems } from '../../../../apis/finances/cards';

const InvoiceListModal = ({ open, setOpen, cardData, detailSubmit, type }) => {
  const [fields, setFields] = useState([]);
  const [filters] = useState([
    {
      title: '조회기간',
      type: 'customdatepicker',
      key: 'range.writeDate',
    },
  ]);

  useEffect(() => {
    setFields([
      { title: "일자", key: "writeDate" },
      { title: "상호", key: type === 'sales' ? "byrCorpName" : "supCorpName" },
      { title: "대표자명", key: type === 'sales' ? "byrRepName" : "supRepName" },
      {
        title: "사업자번호",
        key: type === 'sales' ? "byrBizNo" : "supBizNo",
        validators: ['comNum']
      },
      {
        title: "대표품목",
        key: "items[0].prodName",
        onValue: (value, field, form) => {
          let items = "";
          if (!isEmpty(form.invoiceItems))
          {
            forEach(form.invoiceItems, (item) => {
              if (item.order === 1)
              {
                items =
                  form.invoiceItems.length > 1
                    ? `${item.prodName} 외 ${form.invoiceItems.length - 1}건`
                    : item.prodName;
              }
            });
          }

          return items;
        },
      },
      {
        title: "공급가액",
        key: "supplyAmt",
        type: 'comma'
      },
      {
        title: "세액",
        key: "taxAmt",
        type: 'comma'
      },
      {
        title: "합계금액",
        key: "totalAmt",
        type: 'comma'
      },
      {
        title: "발행여부",
        key: "taxInvoiceIdx",
        onValue: (value, field, form) => {
          let issue = "";
          if (isNull(value))
          {
            issue = "부";
          } else
          {
            // TODO 나중에 현금영수증 발급 추가 될 경우... 변경해야함
            issue = "세금계산서"
          }

          return issue;
        },
      },
    ])
  }, [type])

  const cancel = () => {
    setOpen(false)
    reset()
  }
  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    reset
  } = useForm(
    {
      order: [
        {
          writeDate: "desc"
        },
      ],
      range: {
        writeDate: [getDay(7), getDay()]
      },
      page: 0,
      limit: 10
    },
  )

  useEffect(() => {
    submit(form);
    setSubmit(submit)
  }, []);

  const submit = (params) => {
    getInvoiceList(type, getParams(params)).then((res) => {
      setTotal(res.data.totalCount)
      setList(res.data.invoices)
    }).catch(() => { })
      .finally(() => setIsLoading(false))
  };

  const handleApply = () => {
    const body = {
      list: selectedList.map((d) => ({
        cardUseType: type,
        cardUseIdx: cardData.idx,
        itemType: "invoice",
        itemIdx: d.idx
      }))
    }

    systemAlert('선택된 거래명세서 내역을 연관데이터로 등록하시겠습니까?', {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '확인',
          onClick: () => {
            createCardRecordsUseItems(body).then(() => { detailSubmit(); cancel(); })
          }
        }
      ]
    })
  }

  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange} />
      <ControlTable
        title={`거래명세서 ${type === 'sales' ? '매출' : '매입'}리스트`}
        fields={fields}
        list={list}
        selectedList={selectedList}
        setSelected={setSelectedList}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={true}
        submit={handleSubmit}
      />
      <div className="submit-button-wrap float-right margin-top-32">
        <Button
          className="button"
          size="lg"
          label="취소"
          color="text"
          action={cancel}
        />
        <Button
          className="button"
          size="lg"
          label="적용하기"
          action={handleApply}
          disabled={isEmpty(selectedList)}
        />
      </div>
    </>
  )
}

export default InvoiceListModal;